document.addEventListener('turbolinks:load', function () {
    if ($('.code_enforcements.new, .code_enforcements.create, .code_enforcements.edit, .code_enforcements.update').length === 0) {
        return false
    }

    $(document).off('change', '.search-master-violation').on('change', '.search-master-violation', function() {
        let masterViolationId = $(this).val()
        let violationForm = $(this).closest('.violation-form');

        var violationSelect = violationForm.find('.search-violation-type');
        violationSelect.empty().append('<option value="">Select Violation Type</option>');

        if(masterViolationId) {
            var organizationId = $('#code_enforcement_organization_id').val();
            $.ajax({
                method: 'GET',
                url: `/organizations/${organizationId}/ce_master_violations/${masterViolationId}/ce_violations`
            }).done(function(response) {
                var data = response.data;
                data.forEach(function(violation) {
                    var label = violation.year ? `${violation.title} (${violation.year})` : violation.title;
                    violationSelect.append($('<option>', { value: violation.title, text: label }));
                });
            });
        }
    })

    $(document).off('change', '.search-violation-type').on('change', '.search-violation-type', function () {
        let violation = $(this).val()
        let $violationForm = $(this).closest('.violation-form');

        if (violation) {
            var organizationId = $('#code_enforcement_organization_id').val()
            var dateOfVisit = $('#code_enforcement_date_of_visit').val()
            $.ajax({
                method: 'GET',
                url: `/organizations/${organizationId}/ce_violations/details`,
                data: {
                    title: violation,
                    date_of_visit: dateOfVisit
                }
            }).done(function (res) {
                if (res.error) {
                    alert(res.error)
                } else {
                    var data = res.data
                    var deadline = data.deadline
                    var municipalOrdinance = data.municipal_ordinance
                    var correctiveMeasure = data.corrective_measure
                    var notesOfViolation = data.notes_of_violation
                    var ce_violation_id = data.ce_violation_id
                    var description = data.description

                    if (municipalOrdinance) {
                        const municipalInput = $violationForm.find('input[name*="[municipal_ordinance]"]').first();
                        const municipalEditor = municipalInput.siblings('trix-editor')[0];
                        if (municipalEditor && municipalEditor.editor) {
                            municipalEditor.editor.loadHTML(municipalOrdinance);
                        }
                    }

                    if (correctiveMeasure) {
                        const correctiveInput = $violationForm.find('input[name*="[corrective_measures]"]').first();
                        const correctiveEditor = correctiveInput.siblings('trix-editor')[0];
                        if (correctiveEditor && correctiveEditor.editor) {
                            correctiveEditor.editor.loadHTML(correctiveMeasure);
                        }
                    }

                    if (notesOfViolation) {
                        const notesInput = $violationForm.find('input[name*="[notes_of_violation]"]').first();
                        const notesEditor = notesInput.siblings('trix-editor')[0];
                        if (notesEditor && notesEditor.editor) {
                            notesEditor.editor.loadHTML(notesOfViolation);
                        }
                    }

                    if (deadline) {
                        const dateField = $violationForm.find('.compliance-deadline.date-picker')[0];
                        if (dateField) {
                            const fp = flatpickr(dateField, {
                                altInput: true,
                                altFormat: "m/d/Y",
                                dateFormat: "Y-m-d",
                                allowInput: true
                            });
                            fp.setDate(deadline);
                        }
                    }

                    if(ce_violation_id) {
                        const ceViolationIdInput = $violationForm.find('input[name*="[ce_violation_id]"]').first();
                        ceViolationIdInput.val(ce_violation_id)
                    }

                    const el = $violationForm.find('.violation-description');
                    if(description.trim().length) {
                        const prefix=`<p><i class="fa fa-question-circle violation-description me-2"></i><i>Description</i></p>`;
                        el.removeClass('d-none');
                        el.html(prefix + description);
                    } else {
                        el.addClass('d-none');
                    }
                }
            }).fail(function (res) {
                console.log(res)
            });
        }
    })
});
